<template>
  <b-col>
    <HotelInfo :info="result.hotelInfo" />
    <b-row v-if="showPrices">
      <b-col md="12">
        <div class="table-responsive">
          <h6 class="package-title">Detalii tarif</h6>
          <table class="table table-sm border table-hover">
            <thead class="t-head hh-t-head">
              <tr>
                <td>Tip camera</td>
                <td></td>
                <td>Tip masa</td>
                <td>Pret catalog</td>
                <td>Pret redus</td>
                <td>Disponibilitate</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="category in result.categories">
                <Category
                  :category="category"
                  :currency="currency"
                  :showCollapse="false"
                  :showBook="false"
                  :fees="fees"
                  :starRating="result.stars"
                  :noRooms="noRooms"
                  transport="own"
                  :key="'categoryInfo' + category.id" />
              </template>
            </tbody>
          </table>
          <Legend/>
          <p class="package-warning">*Atentie! Pretul redus este valabil in limita disponibilitatilor!</p>
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import Legend from '@/app/private/shared/components/legend'
import HotelInfo from '@/app/private/shared/components/hotel_info'
import Category from '@/app/private/shared/components/category_result'

export default {
  name: 'detailedInfo',
  props: {
    result: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    showPrices: {
      type: Boolean,
      required: false,
      default: true
    },
    fees: {
      type: Object,
      default: () => { return {} }
    },
    noRooms: {
      type: Number,
      default: 1
    }
  },
  components: { HotelInfo, Category, Legend }
}
</script>
